export default function slugify(string: string) {
  if (typeof string !== 'string') return null;
  return string
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
}
